import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectPopMessageSettingOption')(function selectPopMessageSettingOption(popMessageDeleteEnabled, state) {
    var optionState = state.optionState;
    optionState.popMessageDeleteEnabled = popMessageDeleteEnabled;
}));
//# sourceMappingURL=selectPopMessageSettingOption.js.map